import ApiBase from '../ApiBase';

class SiteHardPassword extends ApiBase {
    route = '/base/site-hard-password';

    /**
     * @method login
     * @param {object} data
     * @return {Promise<*>}
     */
    login = (data) => {
        return this.post(this.route + '/login', data, 'login');
    };

    /**
     * @method check
     * @param {object} data
     * @return {Promise<*>}
     */
    check = (data) => {
        return this.get(this.route + '/check', data);
    };
};

export default new SiteHardPassword();